import _ from 'underscore';
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withProps } from '@bingads-webui-react/with-props';
import { subscribeToSchedulingViewLiveUpdates } from './scheduling-view-realtime-subscription';

function Scheduling({
  id, LegacySchedulingView, value, onChange, hideStartAndEndDate,
}) {
  const view = useRef();
  let container;

  const validate = useCallback(() => {
    onChange({
      isValid: view.current.validate(),
      value: view.current.toObject(),
    });
  }, [onChange, view]);

  useEffect(() => {
    view.current = new LegacySchedulingView(_.extend(
      {},
      {
        labelClass: 'scheduling__label',
        controlClass: 'scheduling__control',
        model: value || {},
        hideStartAndEndDate,
      }
    ), [hideStartAndEndDate]);

    subscribeToSchedulingViewLiveUpdates(view.current, validate);

    view.current.render();
    view.current.$el.appendTo(container);

    return () => { view.current.remove(); };
    // We want the view to be created only once,
    // hence ignoring all dependencies of this "effect".
    // This means that view will ignore changes to all props.
    // If need be to make view pick props updates, the view
    // need to provide a way to communicate such update to it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id={id}
      className="form-horizontal"
      ref={(ref) => { container = ref; }}
    />
  );
}

Scheduling.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({}),
  LegacySchedulingView: PropTypes.func.isRequired,
  hideStartAndEndDate: PropTypes.bool,
};

Scheduling.defaultProps = {
  value: undefined,
  hideStartAndEndDate: false,
};

export function buildSchedulingView(LegacySchedulingView) {
  return withProps({ LegacySchedulingView }, Scheduling);
}
